import React from "react";
import { CATEGORY_CONFIG } from "../../constant/offerFormConfig";

const CreatePricingDetailsComp = ({ form, handleChange }) => {
	const config = CATEGORY_CONFIG[form.category];

	return (
		<div className="card-box">
			<h6>Pricing</h6>

			<div className="row g-2">
				<div className="col-6">
					<div className="d-flex justify-content-between">
						<label>Original price</label>
					</div>
					<input
						name="originalPrice"
						placeholder="ex. Rs.3999"
						type="number"
						className="form-control custom-input col"
						onChange={handleChange}
					/>
				</div>
				<div className="col-6">
					<div className="d-flex justify-content-between">
						<label>Discounted price</label>
					</div>
					<input
						name="discountedPrice"
						placeholder="ex. Rs.2999"
						type="number"
						className="form-control custom-input col"
						onChange={handleChange}
					/>
				</div>
			</div>

			{config?.showMinOrder && (
				<>
					<div className="d-flex justify-content-between pt-3">
						<label>Min order value</label>
					</div>
					<input
						name="minOrderValue"
						placeholder="ex. Rs.999"
						type="number"
						className="form-control custom-input"
						onChange={handleChange}
					/>
				</>
			)}

			<>
				<div className="d-flex justify-content-between pt-3">
					<label>Max discount</label>
				</div>
				<input
					name="maxDiscount"
					placeholder="Max discount"
					type="number"
					className="form-control custom-input"
					onChange={handleChange}
				/>
			</>
		</div>
	);
};

export default CreatePricingDetailsComp;
